<template>
    <header class="header">
        <div class="head-top-right">
            <div class="main-container">
                <el-breadcrumb separator="|">
                    <el-breadcrumb-item><a href="http://www.dahuahome.com/" target="_blank"><img src="../assets/imgs/icon-pc.png" class="icon-top">走进大华</a></el-breadcrumb-item>
                    <template v-if="$root.stockId"><!--  :to="{ path: $root.isPublic?'/home':'/' }" -->
                        <el-breadcrumb-item @click.native="clearInMng();$root.isPublic=!$root.isPublic;$router.push($root.isPublic?'/':'/home');"><img src="../assets/imgs/icon-home.png" class="icon-top">{{$root.isPublic?'管理中心':'回到首页'}}</el-breadcrumb-item>
                        <el-breadcrumb-item @click.native="clearInMng();$root.logout();$root.isPublic=true" :to="{ path: '/login' }"><img src="../assets/imgs/icon-out.png" class="icon-top">登出</el-breadcrumb-item>
                    </template>
                    <template v-else>
                        <el-breadcrumb-item @click.native="$router.push('/login');" :to="{ path: '/login' }"><img src="../assets/imgs/icon-login.png" class="icon-top">登录</el-breadcrumb-item>
                        <el-breadcrumb-item @click.native="$router.push('/register');" :to="{ path: '/register' }"><img src="../assets/imgs/icon-edit.png" class="icon-top">注册</el-breadcrumb-item>
                    </template>
                    <el-breadcrumb-item :to="{ path: '/help' }"><img src="../assets/imgs/icon-help.png" class="icon-top">帮助中心</el-breadcrumb-item>
                    <el-breadcrumb-item @click.native="download" v-if="$root.env != 'prod'"><img src="../assets/imgs/icon-mobile.png" 
                         class="icon-top"><b style="color:#303133;cursor:pointer;">下载手机APP</b></el-breadcrumb-item>
                    <el-popover v-else placement="bottom" trigger="click">
                        <el-table :data="tableDate" style="width: 100%">
                            <el-table-column align="center" prop="androidImgUrl" label="安卓" width="150">
                                <template slot-scope="scope">
                                    <img :src="scope.row.androidImgUrl" width="100px" height="100px">
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="iosImgUrl" label="IOS" width="150">
                                <template slot-scope="scope">
                                    <img :src="scope.row.iosImgUrl" width="100px" height="100px">
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-breadcrumb-item slot="reference"><img src="../assets/imgs/icon-mobile.png" class="icon-top">
                            <b style="color:#303133;cursor:pointer;">下载手机APP</b>
                        </el-breadcrumb-item>
                    </el-popover>
                </el-breadcrumb>
            </div>
        </div>

        <div class="main-container" :class="$route.name=='Index'? 'home-nav':''">
            <img src="../assets/imgs/logo-dh.png" style="vertical-align: super; margin-right: 200px;">
            <el-menu :default-active="$root.activeIndex" ref="menus" :activeIndex="$root.activeIndex" class="head-menu" mode="horizontal" @select="$parent.handleSelect">
                <el-menu-item index="home" @click="$router.push($root.isPublic?'/':'/home')">首页</el-menu-item>
                <el-menu-item v-if="$root.isPublic?true:($root.loginUserType === '0')" index="invite" @click="$router.push($root.isPublic?'/inviteList':'/inviteMngList')">{{$root.isPublic?'招标公告':'招标管理'}}</el-menu-item>
                <el-menu-item index="win" @click="$router.push('/winList')">中标公告</el-menu-item>
                <!--<el-menu-item index="4">联系我们</el-menu-item>-->

                <!--<el-menu-item index="tunlComp" @click="$router.push('/tunlList')" v-if="$root.stockId && !$root.isPublic">投诉通道</el-menu-item>-->
                <!--<el-menu-item index="tunlRep" @click="$router.push('/tunlListRep')" v-if="$root.stockId && !$root.isPublic">举报通道</el-menu-item>-->

                <el-menu-item index="tunlComp" @click="" v-if="$root.stockId && !$root.isPublic">
                    <el-tooltip placement="bottom">
                        <div slot="content">甲方接受乙方实名或匿名举<br>报，并对投诉者的信息保密，<br>举报受理部门为大华集团审<br>计部，举报统一受理邮箱为<br>{{ email.tousu }}</div>
                        <a class="no-underline" :href="'mailto:'+ email.tousu">投诉通道</a>
                    </el-tooltip>
                </el-menu-item>
                <el-menu-item index="tunlRep" @click="" v-if="$root.stockId && !$root.isPublic">
                    <el-tooltip placement="bottom">
                        <div slot="content">本合同履行期间，乙方对于甲方、<br>建设方相关业务流程或人员履职<br>情况等如有建议或需投诉的，可<br>以邮件方式提交至大华集团成<br>本招采中心，统一受理邮箱为<br>{{ email.jubao }}</div>
                        <a class="no-underline" :href="'mailto:'+ email.jubao">举报通道</a>
                    </el-tooltip>
                </el-menu-item>

                <el-menu-item index="setting" @click="$router.push('/supplier')" v-if="$root.stockId && !$root.isPublic && ($root.loginUserType === '0')">基本信息</el-menu-item>
            </el-menu>
        </div>

        <!-- 顶部图片 -->
        <div class="head-bg" v-if="$route.name!='Index'"><img :src="$root.headImage.src" :width="$root.headImage.width" :height="$root.headImage.height" alt="" onerror="__setImageHeight(this,0)" onload="__setImageHeight(this,'auto')"></div>

        <!-- 面包屑 -->
        <div class="container-center" id="toTopAnchor" v-if="$root.navs.length">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: $root.isPublic?'/':'/home' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item v-for="nav,idx in $root.navs" :to="{ path: nav.path }" :key="idx">{{nav.name}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    </header>
</template>

<script type="text/babel">

import util from '@/util'

export default {
    name: 'page-header',
    data () {
        return {
            email: util.email,
            tableDate: [
                {
                    androidImgUrl: require('../assets/imgs/android_insatll.png'),
                    iosImgUrl: require('../assets/imgs/app_install.png')
                }
            ]
        }
    },
    methods: {
        clearInMng: function() {
            var val = this.$root.isPublic ? 'is' : ''
            window.localStorage.setItem('isInMng',val)
        },
        download: function () {
            var url = ''
            switch(this.$root.env){
                case 'qa': url = 'https://www.pgyer.com/semqa';break;
                case 'uat': url = 'https://www.pgyer.com/semUAT';break;
                // case 'prod': url = 'http://link.weigongju.org/21940832';break;
                default: break;// todo: production url
            }
            window.open(url, '_blank')
        },
        created() {
        },
    }
}
window.__setImageHeight = function(img, h){
    img.style.height = h;
    img.style.visibility = h?'visible':'hidden';
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="postcss">
@import '../assets/common.css';

    header {
        border-bottom: 1px solid #E4E5E4;
    }

    .el-breadcrumb {
        height: 44px;
        line-height: 44px;
    }

    .head-top-right .el-breadcrumb{
        height: auto;
        line-height: 1;
    }

    .head-top-right {
        background: #f5f5f5;
        text-align: right;
        padding: 10px;
        border-bottom: 1px solid #e5e5e5;
        min-width: var(--wrapwidth);
        & .el-breadcrumb{
            display: inline-block;
        }
        & .el-breadcrumb__inner{
            color: #777;
            font-weight: 400;
        }
        & .el-breadcrumb__inner a{
            text-decoration: none;
        }
    }
    .header .home-nav {
        z-index: 3;
        position: relative;
        background: #fff;
    }
    .header .home-nav img {
        padding-left: 25px;
    }
    .head-menu{
        display: inline-block;
    }
    .head-menu.el-breadcrumb:before{
        content: '当前位置：';
        float: left;
    }
    .el-menu--horizontal{
        border-bottom: none;
    }
    .el-menu-item{
        padding: 0 30px;
    }
    .el-menu--horizontal .el-menu-item{
        color: #333;
        border-bottom: none;
    }
    .el-menu--horizontal>.el-menu-item.is-active, .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
        border-bottom: none;
        color: var(--mainColor);
        font-weight: bold;
    }
    .head-bg{
        width: 100%;
        min-width: var(--wrapwidth);
        height: auto;
        background: #4F5054;
        & img{
            display:block;
          }
    }

    .icon-top{
        padding: 0 5px;
        width: 16px;
        height: 16px;
        vertical-align: middle;
    }
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue